module.exports = __webpack_public_path__ + "static/media/createdatafactory.de2a7197.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/Help/assets/createdatafactory.png
// module id = 1870
// module chunks = 193